/**
 * Is this a phone or a tablet, rather than a computer?
 *
 * Asked by the things that only make sense on one or the other: the camera
 * button, which needs a camera in your hand, and the QR code, which exists to
 * be scanned BY a phone and is therefore pointless ON one.
 *
 * Only the device is asked, never the window. An earlier version also counted
 * "has a touch screen and is under 1024px wide" as mobile, which is true of a
 * touch-screen laptop with its window not maximised — and that took the QR
 * code off a desktop and put a camera button on it.
 *
 * - `userAgentData.mobile` is the browser's own answer, where it exists.
 * - The agent string names the rest.
 * - iPadOS reports itself as a Mac, so a Mac with a touch screen is one: no
 *   Mac has ever had one.
 *
 * Read once at load. A device does not become a phone while the page is open,
 * and a window being resized is not a device changing.
 */
const agent = navigator.userAgent || '';

const iPadOS = /Macintosh/.test(agent) && (navigator.maxTouchPoints || 0) > 1;

export const isMobileDevice = navigator.userAgentData?.mobile === true
    || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(agent)
    || iPadOS;
